import HeartTopChart from '@assets/icons/heart-top-chart.svg'
import { Icon } from './Icon'

export const HeartTopChartIcon = Icon(HeartTopChart)
